import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const CircleFilledIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props} viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="7.184" className={`icon--${props.color}`} />
    </IconSvgWrapper>
  );
};

export default CircleFilledIcon;
